import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    width: "96vw",
    top: "-0.4rem",
    position: "relative",
    zIndex: 999999,
    backgroundColor: theme.kooee.backgrounds.primary,
    marginBottom: "1vh"
  },
  control: {
    padding: theme.spacing(2)
  }
}));
